import useSWRMutation, { SWRMutationResponse } from "swr/mutation";
import { Contract } from "../../types";
// @ts-ignore
import useHttpClient from "../useHttpClient";
import { AxiosInstance } from "axios";

export interface SignContractArgs {
  uuid: string;
  otp: string;
  deviceInfo?: string;
  sessionId?: string;
}

const useSignContract = (): SWRMutationResponse<Contract, Error, SignContractArgs, "sign-contract"> => {
  const httpClient: AxiosInstance = useHttpClient();

  return useSWRMutation(
    "sign-contract",
    async (_key, { arg }: { arg: SignContractArgs }): Promise<Contract> => {
      const { uuid, otp, deviceInfo, sessionId } = arg;
      const response = await httpClient.post(
        `/contracts/${uuid}/sign`,
        {
          deviceInfo,
          sessionId,
        },
        {
          headers: {
            Otp: otp,
          },
        }
      );
      return response.data.data;
    }
  );
};

export default useSignContract;

